import React, {useState} from 'react';
import { Modal, Button } from 'react-daisyui';

interface ChangeDemographicConfirmModalProps {
    isOpen: boolean;
    closeModal: () => void;
    handleConfirm: () => void;
  }

const ChangeDemographicConfirmModal: React.FC<ChangeDemographicConfirmModalProps>  = ({
    isOpen,
    closeModal,
    handleConfirm
}) => {
    return (
        <Modal open={isOpen}>
        <Modal.Header>
            <h1>Confirm Demographic Change</h1>
        </Modal.Header>
        <Modal.Body>
            <p>Changing the Demographic will reset the selected study group and optional measures. Are you sure you want to proceed?</p>
        </Modal.Body>
        <Modal.Actions>
            <Button id='ModalCancelButton' type='button'  onClick={closeModal}>
            Cancel
            </Button>
            <Button id='ModalConfirmButton' type='button' color="primary" onClick={handleConfirm}>
            Confirm
            </Button>
        </Modal.Actions>
        </Modal>
    )
}

export default ChangeDemographicConfirmModal;